import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const InvoiceService = {
    
  getAllInvoice: async () => {
    try {
      const response = await axios.get(ENDPOINT.Invoice);
      return response.data;
    } catch (error) {
      console.error("Error fetching Invoice:", error.message);
      throw error;
    }
  },

   getLastInvoice: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.Invoice}/last`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Invoice:", error.message);
      throw error;
    }
  },

  getInvoiceProjectMap: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.Invoice}/project`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Invoice:", error.message);
      throw error;
    }
  },

  getAllInvoiceById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.Invoice}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Invoice:", error.message);
      throw error;
    }
  },

  getAllActiveInvoiceById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.activeInvoice}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Invoice:", error.message);
      throw error;
    }
  },

   getInvoiceDetailsById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.Invoice}/eq/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Invoice:", error.message);
      throw error;
    }
  },

  createInvoice: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.Invoice, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Invoice:", error.message);
      throw error;
    }
  },

  updateInvoice: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.Invoice}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Invoice:", error.message);
      throw error;
    }
  },

  updateQUotationRow: async (data) => {
    try {
      const response = await axios.put(`${ENDPOINT.quotation}/invoice`, JSON.stringify(data),
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Invoice:", error.message);
      throw error;
    }
  },


  deleteInvoice: async ( id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.Invoice}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching quotation:", error.message);
      throw error;
    }
  },

  createCustomer: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.customer, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Invoice:", error.message);
      throw error;
    }
  },

  updateCustomer: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.customer}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Invoice:", error.message);
      throw error;
    }
  },
}